import React, { useState, useReducer, useContext } from "react";
import { useTranslation } from "react-i18next";
import { cleanJoin } from "../../../../../utils/stringUtil";
import { reducer } from "../RequestPreviewDocumentsPageReducer";
import { Column } from "../../../../../common/columns";
import { MessageContext } from "../../../../../common/message";
import { back } from "../PreviewDocumentsUtils";

function ErrorSupplementTextarea({ docState, disabled, setIsBlocking, setSelected }) {
  const { t } = useTranslation();
  const [doc, dispatch] = useReducer(reducer, docState);
  const message = useContext(MessageContext);

  const [docError, setDocError] = useState(
    doc.error !== undefined && doc.error !== null ? doc.error : ""
  );

  const handleChange = (event) => {
    setDocError(event.target.value);
  };

  const errorUpdate = () => {
    dispatch({ type: "sendError", payload: [docError, doc] });
    message.toggle({
      title: t("modalMessage.titleInfo"),
      content: t("requests.documentAcceptance.supplementReasonSubmit"),
      hideNo: true,
      yesLabel: t("modalMessage.okLabel"),
      onYes: () => {
        message.toggle({});
        back(setSelected, setIsBlocking, disabled);
      },
    });
  };

  return (
    <Column className="is-centered is-one-fifth">
      <div id="supplementReason" className={doc.color === "red" ? "is-block" : "is-hidden"}>
        <p>{t("requests.documentAcceptance.supplementReason")}</p>
        {!disabled ? (
          <>
            <textarea
              id="textArea"
              placeholder={docError || t("requests.documentAcceptance.placeholder")}
              value={docError}
              className="textarea mr-2 mt-2"
              rows="20"
              onChange={handleChange}
            />

            <button
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "is-pulled-right",
                "no-focus-outline",
                "has-border-green-1",
                "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
              )}
              disabled={doc.error !== docError && docError !== "" ? false : true}
              onClick={errorUpdate}
            >
              {t("requests.documentAcceptance.action.submit")}
            </button>
          </>
        ) : (
          <p>{docError || "---"}</p>
        )}
      </div>
    </Column>
  );
}

export default ErrorSupplementTextarea;
